import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DetailSubsection } from './DetailSubsection';
import React from 'react';
import { SonarText } from '@ui/text';
import { useSonarObjectReference } from '@hooks';

export interface ApiNameProps {
	sonarObjectId: number;
}

export const ApiName: React.FC<ApiNameProps> = ({ sonarObjectId }) => {
	const { internalName } = useSonarObjectReference(sonarObjectId ?? 0);

	return (
		<DetailSubsection
			className='inline-metadata'
			title={ COPY_SPECIFIC.API_NAME }
			titleExtra={ <SonarText> { internalName } </SonarText> } />
	);
};

